<template>
  <div id="pageTable">
    <v-container grid-list-xl>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field
                v-model="search"
                flat
                hide-details
                :placeholder="$t('action.buttons.search')"
                prepend-icon="search"
                solo
              />
              <v-btn small color="primary" @click="sendEmit('create')">
                {{ $t('action.buttons.new') }}
              </v-btn>
            </v-toolbar>
            <v-divider />
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :items="formatList"
                :rows-per-page-items="[10, 25, 50]"
                :search="search"
                class="elevation-1"
                item-key="_id"
                :pagination.sync="pagination"
                :loading="loading"
              >
                <template slot="items" slot-scope="props">
                  <td>
                    <i
                      v-if="props.item.active"
                      class="success--text icon material-icons"
                      >check_circle</i
                    >
                    <i v-else class="error--text icon material-icons">cancel</i>
                  </td>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.createdAt }}</td>
                  <td>{{ props.item.createdBy }}</td>
                  <td>{{ props.item.updatedAt }}</td>
                  <td>{{ props.item.updatedBy }}</td>
                  <td class="justify-center layout px-0">
                    <v-btn flat icon color="primary">
                      <v-icon
                        class="icon material-icons"
                        @click="sendEmit('clone', props.item._id)"
                      >
                        file_copy
                      </v-icon>
                    </v-btn>
                    <v-btn flat icon color="success">
                      <v-icon
                        class="icon material-icons"
                        @click="sendEmit('update', props.item._id)"
                      >
                        create
                      </v-icon>
                    </v-btn>
                    <v-btn flat icon color="error">
                      <v-icon
                        class="icon material-icons"
                        @click="sendEmit('delete', props.item._id)"
                      >
                        delete
                      </v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-title class="headline"> Confirme Clonacion </v-card-title>

        <v-card-text> ¿Realmente desea clonar este curso? </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn color="primary darken-1" flat="flat" @click="yesClone()">
            Confirmar
          </v-btn>

          <v-btn color="error darken-1" flat="flat" @click="noClone()">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { dateFormat } from '../../../helpers/dateHelper'

export default {
  name: 'List',
  data() {
    return {
      isClone: null,
      search: '',
      pagination: {
        sortBy: 'active',
        descending: true,
      },
      complex: {
        headers: [
          {
            text: this.$t('fields.global.state'),
            align: 'center',
            value: 'active',
          },
          {
            text: this.$t('fields.global.name'),
            value: 'name',
          },
          {
            text: this.$t('fields.global.createdAt'),
            align: 'center',
            value: 'createdAt',
          },
          {
            text: this.$t('fields.global.createdBy'),
            align: 'center',
            value: 'createdBy',
          },
          {
            text: this.$t('fields.global.updatedAt'),
            align: 'center',
            value: 'updatedAt',
          },
          {
            text: this.$t('fields.global.updatedBy'),
            align: 'center',
            value: 'updatedBy',
          },
          {
            text: this.$t('fields.global.actions'),
            align: 'center',
            value: '',
          },
        ],
      },
    }
  },
  computed: {
    ...mapState({
      loading: (state) => state.courses.loading,
      listCourses: (state) => state.courses.List,
      listUser: (state) => state.users.listaUsers,
      listTournaments: (state) => state.tournaments.List,
      interCourse: (state) => state.courses.selected,
    }),
    formatList() {
      return this.listCourses.map((course) => {
        return {
          ...course,
          createdAt: dateFormat(course.createdAt, false),
          createdBy: this.formatUser(course.createdBy),
          updatedAt: dateFormat(course.updatedAt, false),
          updatedBy: this.formatUser(course.updatedBy),
        }
      })
    },
    dialog() {
      return this.isClone !== null
    },
  },
  methods: {
    ...mapActions({
      getOne: 'courses/setOne',
      setClone: 'courses/setClone',
    }),
    sendEmit(evento, id = null) {
      if (
        evento !== 'delete' &&
        evento !== 'create' &&
        evento !== 'update' &&
        evento !== 'clone'
      ) {
        return
      }
      switch (evento) {
        case 'create':
          this.$emit('create')
          break
        case 'update':
          this.getOne(id)
          this.$emit('update')
          break
        case 'delete':
          this.getOne(id)
          this.$emit('remove')
          break
        case 'clone':
          this.getOne(id)
          this.isClone = id
          break
      }
    },
    formatTournament(id) {
      return this.listTournaments.find((item) => item._id === id) || 'Sin datos'
    },
    resolveContent(content) {
      console.log(content)
      let result = ''
      let temporal = null
      switch (this.$i18n.locale) {
        case 'en':
          temporal = content.find(
            (item) => item.iso === '5bd9f3ee7fa5610014fed21f'
          )
          if (temporal) {
            result = temporal.text
          }
          break
        case 'es':
          temporal = content.find((item) => item.iso === 'es-ES')
          if (temporal) {
            result = temporal.text
          }
          break
        case 'ca':
          temporal = content.find(
            (item) => item.iso === '5c8011ee80c7daaa57123a68'
          )
          if (temporal) {
            result = temporal.text
          }
          break
      }
      const points = result.length > 40 ? ' ...' : ''
      return result.substring(0, 40) + points
    },
    noClone() {
      this.isClone = null
    },
    yesClone() {
      if (this.isClone) {
        this.setClone(this.interCourse)
      }
      this.isClone = null
    },
  },
}
</script>

<style scoped>
.success--text {
  color: green;
}

.error--text {
  color: red;
}
</style>
